<template>
  <svg
    :class="size"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      opacity="0.5"
      x="1"
      y="5.51562"
      width="16.8029"
      height="10.9352"
      rx="2"
      :stroke="pickColor"
      stroke-width="2"
    />
    <rect
      x="4.19714"
      y="1.5498"
      width="16.8029"
      height="10.9352"
      rx="2"
      fill=""
      :stroke="pickColor"
      stroke-width="2"
    />
    <rect
      x="15.1039"
      y="4.34961"
      width="3.86733"
      height="2.53376"
      rx="1"
      :fill="pickColor"
    />
  </svg>
</template>
<script>
import pickColor from '@/mixins/global'
export default {
  mixins: [pickColor],
  props: {
    size: {
      type: String,
      default: 'h-5 w-5'
    },
    active: {
      type: Boolean,
      default: true
    }
  }
}
</script>
